import { LoadingLarge, Select } from '@spoiler-alert/ui-library';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import Tracking from '../../utilities/tracking-apis';

const useStyles = createUseStyles(
  {
    loadingContainer: {
      height: 'calc(100vh - 75px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    controls: {
      marginBottom: 8,
    },
    select: {
      width: 523,
    },
    iframeWrapper: {
      height: 'calc(100vh - 135px)',
    },
  },
  { name: 'HolisticsDashboard' },
);

const HolisticsDashboardIframe = ({ loading, dashboards, defaultDashboardId, match, handleReportChange, dropdownOptions }) => {
  const classes = useStyles();
  const selectedReportId = match.params.reportId ? match.params.reportId : defaultDashboardId;

  const selectedReport = dashboards.find((d) => d.reportId === selectedReportId);

  useEffect(() => {
    if (selectedReport) {
      Tracking.Event('Viewed Holistics Dashboard', {
        dashboardName: selectedReport.name,
        defaultViewOnPageLoad: selectedReport.reportId === defaultDashboardId,
      });
    }
  }, [selectedReport, defaultDashboardId]);

  const dashboardURL = selectedReport ? selectedReport.embed.url : '';

  const selectedItem = selectedReport ? [{ value: selectedReport.reportId, text: selectedReport.name }] : [];

  return (
    <div>
      {loading || !defaultDashboardId ? (
        <div className={classes.loadingContainer}>
          <LoadingLarge />
        </div>
      ) : (
        <>
          <div className={classes.controls}>
            <Select containerClassName={classes.select} label="Select report" search selectedItems={selectedItem} onChange={handleReportChange}>
              {dropdownOptions}
            </Select>
          </div>
          <div className={classes.iframeWrapper}>
            <iframe
              title="Embedded Holistics Dashboard"
              src={dashboardURL}
              id="embedded-iframe"
              style={{ width: '100%', height: '100%' }}
              frameBorder="0"
              allowFullScreen
              allow="clipboard-read; clipboard-write"
            />
          </div>
        </>
      )}
    </div>
  );
};

HolisticsDashboardIframe.propTypes = {
  dashboards: PropTypes.array,
  defaultDashboardId: PropTypes.string,
  match: PropTypes.object,
  handleReportChange: PropTypes.func,
  dropdownOptions: PropTypes.node,
  loading: PropTypes.bool,
};

export default HolisticsDashboardIframe;
